import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './core/pages/page-not-found/page-not-found.component';
import { AuthGuard } from './core/guards/auth.guard';
import { MainLayoutComponent } from './shared/pages/main-layout/main-layout.component';
import { LoginComponent } from './core/pages/login/login.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },

  {
    path: 'admin',
    canMatch: [AuthGuard],
    component: MainLayoutComponent,
    loadChildren: () => import('./core/core.module').then((m) => m.CoreModule),
  },

  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
